import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware((_, from: RouteLocationNormalized) => {
  if (from.name !== 'checkout-complete') {
    return navigateTo('/');
  }
});
